export default __webpack_public_path__ + "static/media/tickets_inactive.60758481.svg";